export function getAmpVideoElement(player) {
  // https://amp.azure.net/libs/amp/latest/docs/index.html#amp.player.playerelement
  // in the case where the original search for the player element use the amp api to
  // access the player. For msft, we should be using amp, not some other player.
  const playerContainer = player.playerElement();
  return playerContainer && playerContainer.getElementsByTagName('video')[0];
}

export function getHlsjsVideoElement(player) {
  // hlsjs attaches to the element directly via attachMedia - https://github.com/video-dev/hls.js/blob/master/docs/API.md#hlsattachmediavideoelement
  // once attached, the media can be returned
  return player.media;
}

export function getVideoJsVideoElement(player) {
  // https://docs.videojs.com/player#el
  // get the video js element and find the video tag it binds to
  // this should work wether it's a video-js tag or a video tag that this player attaches to.
  const container = player.el();
  return container && container.getElementsByTagName('video')[0];
}

export function getShakaVideoElement(player) {
  // https://shaka-player-demo.appspot.com/docs/api/shaka.Player.html getMediaElement
  return player.getMediaElement();
}
